/* template */
<template><div class="wx-launch-btn-wrapper">{{ btnText || '打开APP领取' }}<wx-open-launch-app appid="wx7e8eef23216bade2" :extinfo="jumpTargetScheme" id="launch-btn" :style="wxStyle" @error="wxTagLaunchCkError" @launch="wxTagLaunchCk" @ready="wxTagReady"><script type="text/wxtag-template"><style>
        .wx-launch-app-btn {
          width: 1000px;
          height: 300px;
        }
      </style>
      <div class="wx-launch-app-btn"></div></script></wx-open-launch-app></div></template>

/* styles */
<style lang="scss" scoped mpxStyleOptions='{"mid":"m7e8b7c06"}'>
.wx-launch-btn-wrapper {
  width: 472rpx;
  height: 118rpx;
}
</style>

/* json */
/* script */
<script>
  import processOption, { getComponent, getWxsMixin } from "@mpxjs/webpack-plugin/lib/runtime/optionProcessor"
  const wxsModules = {}
  global.currentModuleId = "m7e8b7c06"
  global.currentSrcMode = "wx"
  /** script content **/
  require("./wx-launch-app-btn.mpx.js?isComponent&outputPath=components%2Fwx-launch-app-btn7e8b7c06%2Findex!=!@mpxjs/webpack-plugin/lib/selector?mode=web&env=!../../../node_modules/@didi/webpack-config-fin/lib/business/webp-loader.js!./wx-launch-app-btn.mpx?ctorType=component&index=0&isComponent&lang=js&mpx&outputPath=components%2Fwx-launch-app-btn7e8b7c06%2Findex&type=script")
  const currentOption = global.__mpxOptionsMap["m7e8b7c06"]
  export default processOption(
    currentOption,
    "component",
    "",
    "components/wx-launch-app-btn7e8b7c06/index",
    {},
    // @ts-ignore
    {},
    // @ts-ignore
    {},
    undefined,
    {},
    undefined,
    getWxsMixin(wxsModules),
    true
  )
</script>
